import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M className={className} initial={{ opacity: 0.001, y }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }} transition={{ duration: 0.9, delay, ease }}>
      {children}
    </M>
  );
};

// Masked line-by-line reveal: each line slides up from behind its mask
const lineV = { hidden: { y: "105%" }, shown: (i) => ({ y: "0%", transition: { duration: 1.1, delay: i, ease } }) };

// Observer sits on the unclipped wrapper; lines inherit the variant
export const MaskLines = ({ lines, className = "", delay = 0.15, inView = false }) => (
  <motion.span className={`block ${className}`} initial="hidden"
    {...(inView ? { whileInView: "shown", viewport: { once: true, amount: 0.1 } } : { animate: "shown" })}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span className="block will-change-transform" variants={lineV} custom={delay + i * 0.12}>{line}</motion.span>
      </span>
    ))}
  </motion.span>
);
